import PropTypes from 'prop-types';
import FormikInputIdentificationNumber from '../../FormikInputIdentificationNumber';
import { InputProps } from './types';

export function Item({ name, config }: InputProps) {
  return <FormikInputIdentificationNumber name={`${name}[0]`} type="text" label={config.name} />;
}

Item.propTypes = {
  name: PropTypes.string,
  config: PropTypes.object
};

export default Item;
